<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon"><md-icon>info</md-icon></div>
          <h4 class="title">About Us — Page Content</h4>
        </md-card-header>

        <md-card-content v-if="loading"><p>Loading...</p></md-card-content>

        <md-card-content v-else>
          <div class="cms-tabs">
            <button v-for="tab in tabs" :key="tab.key"
              :class="['tab-btn', { active: activeTab === tab.key }]"
              @click="activeTab = tab.key">
              {{ tab.label }}
            </button>
          </div>

          <!-- Hero -->
          <div v-if="activeTab === 'hero'" class="cms-section">
            <h5 class="section-label">Hero Section</h5>
            <md-field>
              <label>Page Title</label>
              <md-input v-model="form.hero.title" />
            </md-field>
            <md-field>
              <label>Subtitle</label>
              <md-input v-model="form.hero.subtitle" />
            </md-field>
          </div>

          <!-- Story -->
          <div v-if="activeTab === 'story'" class="cms-section">
            <h5 class="section-label">Our Story Section</h5>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50">
                <md-field><label>Section Subtitle</label><md-input v-model="form.story.subtitle" /></md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field><label>Section Title</label><md-input v-model="form.story.title" /></md-field>
              </div>
              <div class="md-layout-item md-size-100">
                <md-field><label>Image URL</label><md-input v-model="form.story.imageUrl" /></md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field><label>Badge Number (e.g. 5+)</label><md-input v-model="form.story.badgeNumber" /></md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field><label>Badge Text</label><md-input v-model="form.story.badgeText" /></md-field>
              </div>
            </div>
            <div v-for="(para, i) in form.story.paragraphs" :key="i" class="array-row">
              <md-field>
                <label>Paragraph {{ i + 1 }}</label>
                <md-textarea v-model="form.story.paragraphs[i]" />
              </md-field>
              <md-button class="md-icon-button md-danger" @click="form.story.paragraphs.splice(i, 1)">
                <md-icon>delete</md-icon>
              </md-button>
            </div>
            <md-button class="md-success md-sm" @click="form.story.paragraphs.push('')">+ Add Paragraph</md-button>
          </div>

          <!-- Values -->
          <div v-if="activeTab === 'values'" class="cms-section">
            <h5 class="section-label">Core Values</h5>
            <div v-for="(val, i) in form.values" :key="i" class="array-card">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30">
                  <md-field><label>Icon Class</label><md-input v-model="val.icon" placeholder="fas fa-paint-brush" /></md-field>
                </div>
                <div class="md-layout-item md-size-30">
                  <md-field><label>Title</label><md-input v-model="val.title" /></md-field>
                </div>
                <div class="md-layout-item md-size-40">
                  <md-field><label>Description</label><md-input v-model="val.description" /></md-field>
                </div>
              </div>
              <md-button class="md-icon-button md-danger" @click="form.values.splice(i, 1)">
                <md-icon>delete</md-icon>
              </md-button>
            </div>
            <md-button class="md-success md-sm" @click="form.values.push({ icon: '', title: '', description: '' })">+ Add Value</md-button>
          </div>

          <!-- Process -->
          <div v-if="activeTab === 'process'" class="cms-section">
            <h5 class="section-label">Our Process Steps</h5>
            <div v-for="(step, i) in form.process" :key="i" class="array-card">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-20">
                  <md-field><label>Step No.</label><md-input v-model="step.number" placeholder="01" /></md-field>
                </div>
                <div class="md-layout-item md-size-30">
                  <md-field><label>Title</label><md-input v-model="step.title" /></md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field><label>Description</label><md-input v-model="step.description" /></md-field>
                </div>
              </div>
              <md-button class="md-icon-button md-danger" @click="form.process.splice(i, 1)">
                <md-icon>delete</md-icon>
              </md-button>
            </div>
            <md-button class="md-success md-sm" @click="form.process.push({ number: '', title: '', description: '' })">+ Add Step</md-button>
          </div>

          <!-- CTA -->
          <div v-if="activeTab === 'cta'" class="cms-section">
            <h5 class="section-label">CTA Section</h5>
            <md-field><label>CTA Title</label><md-input v-model="form.cta.title" /></md-field>
            <md-field><label>CTA Text</label><md-input v-model="form.cta.text" /></md-field>
          </div>

        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isSaving" @click="save">
            {{ isSaving ? 'Saving...' : 'Save Changes' }}
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import CmsService from "../../../services/CmsService";

export default {
  name: "AboutPageCms",
  data() {
    return {
      loading: true,
      isSaving: false,
      activeTab: "hero",
      tabs: [
        { key: "hero",    label: "Hero" },
        { key: "story",   label: "Our Story" },
        { key: "values",  label: "Values" },
        { key: "process", label: "Process" },
        { key: "cta",     label: "CTA" },
      ],
      form: {
        hero:    { title: "", subtitle: "" },
        story:   { subtitle: "", title: "", imageUrl: "", badgeNumber: "", badgeText: "", paragraphs: [] },
        values:  [],
        process: [],
        cta:     { title: "", text: "" },
      },
    };
  },
  methods: {
    load() {
      CmsService.getPage("about")
        .then((r) => {
          const s = r.data.data.sections;
          this.form.hero    = s.hero    || this.form.hero;
          this.form.story   = s.story   || this.form.story;
          this.form.values  = s.values  || [];
          this.form.process = s.process || [];
          this.form.cta     = s.cta     || this.form.cta;
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    save() {
      this.isSaving = true;
      CmsService.updatePage("about", { sections: this.form })
        .then(() => { this.$toast.success("About page saved!"); this.isSaving = false; })
        .catch(() => { this.$toast.error("Save failed."); this.isSaving = false; });
    },
  },
  beforeMount() { this.load(); },
};
</script>

<style scoped>
.cms-tabs { display:flex; gap:8px; flex-wrap:wrap; border-bottom:2px solid #e2e8f0; margin-bottom:24px; padding-bottom:0; }
.tab-btn { padding:10px 18px; border:none; background:transparent; font-size:14px; font-weight:500; color:#718096; cursor:pointer; border-bottom:3px solid transparent; margin-bottom:-2px; transition:all 0.2s; }
.tab-btn.active { color:#4caf50; border-bottom-color:#4caf50; font-weight:600; }
.cms-section { padding:8px 0 16px; }
.section-label { font-size:15px; font-weight:600; color:#2d3748; margin-bottom:20px; }
.array-card { background:#f8fafb; border:1px solid #e2e8f0; border-radius:10px; padding:16px; margin-bottom:12px; position:relative; }
.array-row { display:flex; align-items:flex-start; gap:8px; }
</style>